const { userAgent: ua } = window.navigator;

export const isIOS = /iPad|iPhone|iPod/i.test(ua);
export const isAndroid = ua.indexOf('android') > -1;
export const isWeixin = ua.indexOf('micromessenger') > -1;
export const isHelloBikeApp = ua.indexOf('app=easybike') > -1;
export const isAlipayMP = ua.indexOf('AlipayClient') > -1 && /MiniProgram|AlipayIDE/.test(ua);
export const isAlipayBrowser = ua.indexOf('AlipayClient') > -1 && !isAlipayMP;

// 判断是否微信小程序webview环境
let _isWxMP = false;
try {
  if (ua.indexOf('miniProgram') > -1) {
    _isWxMP = true;
  } else {
    const ready = () => {
      _isWxMP = (<any>window).__wxjs_environment === 'miniprogram';
    }
    if (!(<any>window).WeixinJSBridge || !(<any>window).WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false)
    } else {
      ready()
    }
  }
} catch {}
export const isWxMP = () => {
  return _isWxMP;
};